module.exports = __webpack_public_path__ + "static/media/1.8c600083.png";